/* 1chancebd — Order Form (COD, 3 fields) */
(function () {
  'use strict';

  const BD_PHONE = /^01[3-9]\d{8}$/;

  function getCookie(name) {
    const row = document.cookie.split('; ').find((r) => r.startsWith(name + '='));
    return row ? decodeURIComponent(row.substring(name.length + 1)) : '';
  }
  function getMetaFbc() {
    const existing = getCookie('_fbc');
    if (existing) return existing;
    try {
      const fbclid = new URLSearchParams(window.location.search).get('fbclid');
      if (!fbclid) return '';
      return 'fb.1.' + Date.now() + '.' + fbclid;
    } catch (_) { return ''; }
  }
  function metaContext() {
    return {
      fbp: getCookie('_fbp') || '',
      fbc: getMetaFbc() || '',
      sourceUrl: window.location.href,
    };
  }
  const modal = () => document.getElementById('OrderModal');
  const t = (key) => (window.LC_I18N && window.LC_I18N[key]) || key;

  // Meta Pixel + CAPI (both, via window.ghTrack — see meta-pixel.liquid):
  // AddToCart fires when the order modal opens (the closest equivalent
  // to "add to cart" in this no-native-cart COD flow), InitiateCheckout
  // fires once the form passes validation and is about to submit.
  // Purchase is intentionally NOT fired here — it's sent server-side via
  // CAPI only, after Shopify actually confirms the order, so ad-blockers
  // /abandoned submits can never inflate it.
  function fbTrack(eventName, items, totalOverride) {
    if (typeof window.ghTrack !== 'function' || !items || !items.length) return;
    const value = totalOverride != null
      ? totalOverride
      : items.reduce((s, i) => s + (Number(i.price) * Number(i.quantity)), 0);
    window.ghTrack(eventName, {
      content_ids: items.map((i) => String(i.variant_id || i.id || '')),
      contents: items.map((i) => ({ id: String(i.variant_id || i.id || ''), quantity: i.quantity, item_price: i.price })),
      content_type: 'product',
      value: Math.round(value),
      currency: 'BDT',
    });
  }

  function money(cents) {
    // Prices stored in whole taka (BDT) via product data on the trigger; format with ৳
    const n = Math.round(Number(cents) || 0);
    return '৳' + n.toLocaleString('en-IN');
  }

  function openModal(items) {
    const m = modal();
    if (!m) return;
    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    m.dataset.items = JSON.stringify(items);
    renderSummary();
    fbTrack('AddToCart', items);
  }
  function closeModal() {
    const m = modal();
    if (!m) return;
    m.classList.remove('is-open');
    document.body.style.overflow = '';
    const status = m.querySelector('[data-order-status]');
    if (status) { status.textContent = ''; status.className = 'order-status'; }
  }

  function currentShipping() {
    const m = modal();
    return Number(m.dataset.shippingCharge || 120);
  }

  function subtotal(items) {
    return items.reduce((s, i) => s + (Number(i.price) * Number(i.quantity)), 0);
  }

  function renderSummary() {
    const m = modal();
    const items = JSON.parse(m.dataset.items || '[]');
    const sub = subtotal(items);
    const ship = currentShipping();
    m.querySelector('[data-sum-subtotal]').textContent = money(sub);
    m.querySelector('[data-sum-shipping]').textContent = money(ship);
    m.querySelector('[data-sum-total]').textContent = money(sub + ship);
  }

  function validate(form) {
    let ok = true;
    ['name', 'phone', 'address'].forEach((n) => {
      const field = form.querySelector('[data-field="' + n + '"]');
      const input = form.elements[n];
      const val = String(input.value || '').trim();
      let bad = !val;
      if (n === 'phone' && !bad) bad = !BD_PHONE.test(val);
      if (n === 'name' && val.length > 100) bad = true;
      if (n === 'address' && val.length > 500) bad = true;
      field.classList.toggle('is-error', bad);
      if (bad) ok = false;
    });
    return ok;
  }

  async function submitOrder(e) {
    e.preventDefault();
    const form = e.target;
    const m = modal();
    const status = m.querySelector('[data-order-status]');
    status.textContent = '';
    status.className = 'order-status';

    if (!validate(form)) return;

    const items = JSON.parse(m.dataset.items || '[]');
    const shipping = currentShipping();
    fbTrack('InitiateCheckout', items, subtotal(items) + shipping);
    const payload = {
      name: form.elements.name.value.trim(),
      phone: form.elements.phone.value.trim(),
      address: form.elements.address.value.trim(),
      shipping: shipping,
      items: items.map((i) => ({ variant_id: i.variant_id, quantity: i.quantity, price: i.price, title: i.title })),
      meta: metaContext(),
    };

    const submitBtn = form.querySelector('[type="submit"]');
    submitBtn.disabled = true;
    const originalLabel = submitBtn.textContent;
    submitBtn.textContent = t('submitting');

    try {
      // Calling the Worker directly (not via the /apps/order App Proxy
      // relay) — Shopify's App Proxy has its own timeout shorter than
      // real order processing (inventory, tax, customer merge) can
      // sometimes take, which was showing customers a false "failed"
      // error on orders that had actually succeeded on Shopify's side.
      const res = await fetch('https://1chancebd-cod-order.onechancebd2929.workers.dev', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('bad_response');
      const data = await res.json();
      // Stash summary for the thank-you page
      try {
        sessionStorage.setItem('gj_last_order', JSON.stringify({
          order_number: data.order_number || '',
          name: payload.name, phone: payload.phone, address: payload.address,
          shipping: payload.shipping,
          items: payload.items,
        }));
      } catch (_) {}
      // Clear Shopify cart in the background — never block the redirect on
      // it, the customer doesn't need to see this finish.
      fetch('/cart/clear.js', { method: 'POST' }).catch(() => {});
      const orderRef = data.order_number ? '?order=' + encodeURIComponent(data.order_number) : '';
      window.location.href = '/pages/thank-you' + orderRef;
    } catch (err) {
      status.textContent = t('error');
      status.classList.add('is-error');
      submitBtn.disabled = false;
      submitBtn.textContent = originalLabel;
    }
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-order-trigger]');
    if (trigger) {
      e.preventDefault();
      let items;
      try { items = JSON.parse(trigger.dataset.items); }
      catch (_) { items = []; }
      if (!items || !items.length) return;
      openModal(items);
      return;
    }
    if (e.target.closest('[data-order-close]') || e.target.matches('.order-modal__scrim')) {
      closeModal();
    }
  });

  document.addEventListener('submit', function (e) {
    if (e.target.matches('#OrderForm')) submitOrder(e);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
